<p-select
  #select
  [options]="userList"
  [multiple]="true"
  [filter]="true"
  filterBy="label"
  [ngModel]="selectedUsers"
  (ngModelChange)="selectedUsers = $event; onChange($event)"
  appendTo="body"
  panelStyleClass="p-select-checkbox-options p-select-toggle-all-inline"
  [placeholder]="placeholder()"
  [lazy]="true"
  dataKey="id"
>
  <!-- The header slot renders above the filter; the overlay is laid out so it
       sits on the filter row instead. Toggles the filtered options only, so
       selections hidden by the current filter are left untouched. -->
  <ng-template #header>
    <div
      class="p-select-toggle-all"
      role="checkbox"
      tabindex="0"
      [attr.aria-checked]="allVisibleSelected(select)"
      [attr.aria-label]="
        allVisibleSelected(select) ? 'Deselect all' : 'Select all'
      "
      [title]="allVisibleSelected(select) ? 'Deselect all' : 'Select all'"
      (click)="toggleAll(select)"
      (keydown.enter)="toggleAll(select)"
      (keydown.space)="toggleAll(select); $event.preventDefault()"
    >
      <p-checkbox
        [ngModel]="allVisibleSelected(select)"
        [binary]="true"
        [readonly]="true"
        [tabindex]="-1"
      />
    </div>
  </ng-template>

  <ng-template #item let-option>
    <p-checkbox
      [ngModel]="isSelected(option.value)"
      [binary]="true"
      [readonly]="true"
      [tabindex]="-1"
    />
    <span>{{ option.label }}</span>
  </ng-template>

  <ng-template #selectedItem>
    <app-selected-chips
      [items]="selectedUsers"
      [label]="chipLabel"
      [key]="chipKey"
      [removable]="true"
      (removeItem)="removeUser($event)"
    />
  </ng-template>
</p-select>
